import React from "react";
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from "@mui/material";
import { ChevronRightIcon } from "./icons";
export function Breadcrumbs({ children }) {
    return (React.createElement(MuiBreadcrumbs, { separator: React.createElement(ChevronRightIcon, { fontSize: "small" }) }, children));
}
export function BreadcrumbLink(props) {
    return (React.createElement(Link, Object.assign({ color: "inherit" }, props)));
}
export function BreadcrumbItem({ children }) {
    return (React.createElement(Typography, { color: "textPrimary" }, children));
}
//# sourceMappingURL=breadcrumbs.js.map